export function readRenderExpanded(
    attrs: Record<string, string> | undefined,
    defaultExpanded: boolean,
): boolean {
    const raw = attrs?.expanded;
    if (raw == null) return defaultExpanded;

    switch (raw.trim().toLowerCase()) {
        case "true":
        case "1":
        case "yes":
        case "on":
            return true;
        case "false":
        case "0":
        case "no":
        case "off":
            return false;
        default:
            return defaultExpanded;
    }
}

export function getRendererAttrs(
    attrs: Record<string, string>,
): Record<string, string> {
    if (!Object.prototype.hasOwnProperty.call(attrs, "expanded")) return attrs;
    const { expanded: _expanded, ...rendererAttrs } = attrs;
    return rendererAttrs;
}
